import { motion } from "framer-motion";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import wsCreationcss from "./../../css/workspaceCreation.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as ImgIcon } from "../../assets/icons/img.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/upload.svg";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { socket } from "../../../services/socket/socket";
import { useDropzone } from "react-dropzone";

import { useState, useEffect } from "react";
import {
  cities,
  createCompany,
  getCompany,
  multiCompany,
  state,
  editCompanyData,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const AddEditCompanyModal = ({
  event = "Edit",
  handleClose,
  fetchCompanies,
  companyData = "",
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const permissions = JSON.parse(localStorage.getItem("permission"));

  const natureOfCompanyList = [
    "Manufacturing",
    "NBFC",
    "Banking",
    "Trading",
    "Other Specify",
  ];

  const functionalCurrencyList = ["INR", "USD", "LKR", "AUD", "PHP", "CAD", "GBP", "EUR", "CHF"];

  const [heading, setHeading] = useState(
    companyData ? "Edit Company" : "Create Company"
  );
  const [organizationName, setOrganizationName] = useState(
    companyData ? companyData?.company_name : ""
  );
  const [natureOfCompany, setNatureOfCompany] = useState(
    companyData ? companyData?.nature_of_company : ""
  );
  const [isOtherSelected, setIsOtherSelected] = useState(
    companyData ? (companyData.nature_of_company && !natureOfCompanyList.includes(companyData.nature_of_company) ? true : false) : false
  );
  const [funcationalCurrency, setFuncationalCurrency] = useState(
    companyData ? companyData?.functional : ""
  );
  const [cinNo, setCINNo] = useState(companyData ? companyData?.ci_no : "");
  const [panTaxNo, setPANTaxNo] = useState(
    companyData ? companyData?.pan_no : ""
  );
  const [city, setCity] = useState(companyData ? companyData?.city : "");
  const [state, setState] = useState(companyData ? companyData?.state : "");
  const [approver, setApprover] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(
    companyData ? companyData?.logo?.originalName : null
  );
  const [previewUrl, setPreviewUrl] = useState(
    companyData ? companyData?.logo?.url : null
  );

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    setUploadedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ".jpeg, .png, .jpg",
  });

  const handleCreateUpdateCompany = async () => {
    let company_code =
      organizationName.slice(0, 3) + Math.floor(1000 + Math.random() * 9000);
    let data = {};
    if (user.responsibilities === "preparer") {
      data = {
        companyName: organizationName,
        companyCode: company_code,
        ci_no: cinNo,
        pan_no: panTaxNo,
        nature_of_company: natureOfCompany,
        functional: funcationalCurrency,
        city: city,
        state: state,
        address: "",
        has_published: "draft",
        status: "waiting",
        approver_id: approver?.approver_id,
        preparer_id: user._id,
      };
    } else {
      data = {
        companyName: organizationName,
        companyCode: company_code,
        ci_no: cinNo,
        pan_no: panTaxNo,
        nature_of_company: natureOfCompany,
        functional: funcationalCurrency,
        city: city,
        state: state,
        address: "",
        has_published: "published",
      };
    }
    if (companyData) {
      if (permissions?.unrestrictedAcessData[0]?.permission?.create === false) {
        swal(
          "Warning",
          "You Don't have Permission to edit Company ",
          "warning"
        );
      } else {
        const formData = new FormData();
        for (let key in data) {
          formData.append(key, data[key]);
        }

        if (uploadedFile) {
          formData.append("file", uploadedFile);
        }
        if (!uploadedFile && !companyLogo) {
          formData.append("deleteLogo", "Y");
        }
        const result = await editCompanyData(companyData._id, formData);
        if (result.status === 200) {
          toast.success("Company Updated successfully.");
          fetchCompanies();
          handleClose();
          if (user.responsibilities === "preparer") {
            socket.emit("add-notification", {
              receiver_id: approver.approver_id,
              description: "updation of company",
              type: "sent approval",
              path: "/Notification",
            });
            socket.emit("get-notification");
          }
          if (result.data.status === false) {
            swal("", result.data.message, "error");
          }
        }
        if (result.data.status === false) {
          swal("", result.data.message, "error");
        }
      }
    } else {
      const formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }

      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }
      const result = await createCompany(formData);
      if (result.status === 200) {
        toast.success("Company added successfully.");
        handleClose();
        fetchCompanies();
      }
      if (result.data.status === false) {
        swal("", result.data.message, "error");
      }
    }
  };

  const isPredefined = natureOfCompanyList.includes(natureOfCompany);

  const dropdownSelected =
  isOtherSelected || (!isPredefined && natureOfCompany !== "")
    ? { label: "Other Specify", value: "Other Specify" }
    : natureOfCompany === ""
    ? { label: "", value: "" } 
    : isPredefined
    ? { label: natureOfCompany, value: natureOfCompany }
    : { label: "Other Specify", value: "Other Specify" };
  

  return (
    <>
      <Modal
        title={heading}
        width="45%"
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                handleClose();
              }}
              label="Cancel"
            />
            {companyData ? (
              <Button
                btnColor={buttoncss.primary}
                label="Update & Save"
                onClick={() => {
                  handleCreateUpdateCompany();
                }}
              />
            ) : (
              <Button
                btnColor={buttoncss.primary}
                label="Create Company"
                onClick={() => {
                  handleCreateUpdateCompany();
                }}
              />
            )}
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{ width: "100%" }}>
          {event === "Edit" && (
            <div>
              {!uploadedFile && !previewUrl && !companyLogo && (
                <div className="mt-1">
                  <span className="input-label">Upload Logo</span>
                  <div
                    className={`d-flex justify-content-center align-items-center radius-8px custom-bg-white-150 ${commoncss.dashedCard}`}
                    style={{ height: "70px" }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: "100px",
                            "flex-direction": "column",
                          }}
                        >
                          <div
                            className={bookclosurecss.addTBCardDescription}
                            style={{ color: "#B3C0BD" }}
                          >
                            Drag and drop your file here
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <motion.div
                className={`${commoncss.dFlex} mt-2`}
                style={{ gap: "10px" }}
              >
                {previewUrl && (
                  <div>
                    <img
                      src={previewUrl}
                      alt="Preview"
                      style={{
                        width: "100px",
                        height: "auto",
                      }}
                    />
                  </div>
                )}
                {uploadedFile && (
                  <button
                    className={wsCreationcss.perviewBtn}
                    type="button"
                    style={{ padding: "5px 7px" }}
                  >
                    <ImgIcon height={19} />
                    {uploadedFile.name}{" "}
                    <CloseIcon
                      height={15}
                      onClick={() => {
                        setUploadedFile(null);
                        setPreviewUrl(null);
                      }}
                    />
                  </button>
                )}

                {companyLogo && (
                  <>
                    <button
                      className={wsCreationcss.perviewBtn}
                      type="button"
                      style={{ padding: "5px 7px" }}
                    >
                      <ImgIcon height={19} />
                      {companyLogo}{" "}
                      <CloseIcon
                        height={15}
                        onClick={() => {
                          setCompanyLogo(null);
                          setPreviewUrl(null);
                        }}
                      />
                    </button>
                    {/* <span
                      className={`${commoncss.primaryLable2} ${commoncss.clickable} ml-1`}
                      onClick={() => {
                        setCompanyLogo(null);
                        setPreviewUrl(null);
                      }}
                    >
                      Replace Image
                    </span> */}
                  </>
                )}
              </motion.div>
            </div>
          )}
          <InputGroup
            label="Organization Name"
            inputs={[
              <>
                <input
                  type="text"
                  value={organizationName}
                  onChange={(e) => setOrganizationName(e.target.value)}
                  placeholder="Enter Organization Name"
                />
              </>,
            ]}
          />

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Nature of Company"
                  inputs={[
                    <>
                      <Dropdown
                        options={natureOfCompanyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        // onSelect={(sel) => {
                        //   setNatureOfCompany(sel.value);
                        // }}
                        onSelect={(sel) => {
                          if (sel.value === "Other Specify") {
                            setIsOtherSelected(true);
                            if (natureOfCompanyList.includes(natureOfCompany)) {
                              setNatureOfCompany("");
                            }
                          } else {
                            setIsOtherSelected(false);
                            setNatureOfCompany(sel.value);
                          }
                        }}
                        placeHolder="Select Nature of Company"
                        selected={dropdownSelected}
                        searchable={true}
                      />
                    </>,
                  ]}
                />
              </>,
              !isPredefined && (
                  <InputGroup
                    label="Specific company nature"
                    inputs={[
                      <input
                        type="text"
                        value={natureOfCompany}
                        onChange={(e) => setNatureOfCompany(e.target.value)}
                        placeholder="Please specify"
                      />
                    ]}
                  />
               ),
            ]}
          />
          <div>
            <InputGroup
              inputs={[
                <>
                  <InputGroup
                    label="CIN No."
                    inputs={[
                      <input
                        type="text"
                        value={cinNo}
                        onChange={(e) => setCINNo(e.target.value)}
                        placeholder="Enter CIN no."
                      />
                    ]}
                  />
                </>,
                <>
                  <InputGroup
                    label="Functional Currency"
                    inputs={[
                      <>
                        <Dropdown
                          options={functionalCurrencyList.map((item, idx) => ({
                            label: item,
                            value: item,
                          }))}
                          onSelect={(sel) => setFuncationalCurrency(sel.value)}
                          placeHolder="Select Functionaly Currency"
                          selected={
                            funcationalCurrency
                              ? {
                                  label: funcationalCurrency,
                                  value: funcationalCurrency,
                                }
                              : { label: "", value: "" }
                          }
                          searchable={true}
                        />
                      </>,
                    ]}
                  />
                </>,
              ]}
            />
          </div>
          <InputGroup
            label="PAN/TAX No."
            inputs={[
              <>
                <input
                  type="text"
                  value={panTaxNo}
                  onChange={(e) => setPANTaxNo(e.target.value)}
                  placeholder="Enter PAN/TAX no."
                />
              </>,
            ]}
          />

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="City"
                  inputs={[
                    <>
                      <input
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        placeholder="Enter City"
                      />
                    </>,
                  ]}
                />
                {/* <InputGroup
                  label="Select City"
                  inputs={[
                    <>
                      <Dropdown
                        options={[].map((connectiontype) => ({
                          label: connectiontype.label,
                          value: connectiontype.value,
                        }))}
                        onSelect={(sel) => setCity(sel.value)}
                        placeHolder={"Select City"}
                        // selected={{ label: "OAuth", value: "OAuth" }}
                      />
                    </>,
                  ]}
                /> */}
              </>,
              <>
                <InputGroup
                  label="State"
                  inputs={[
                    <>
                      <input
                        type="text"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        placeholder="Enter State"
                      />
                    </>,
                  ]}
                />
                {/* <InputGroup
                  label="Select State"
                  inputs={[
                    <>
                      <Dropdown
                        options={[].map((connectiontype) => ({
                          label: connectiontype.label,
                          value: connectiontype.value,
                        }))}
                        onSelect={(sel) => setState(sel.value)}
                        placeHolder={"Select State"}

                        // placeHolder={"Connection Type"}
                        // selected={{ label: "OAuth", value: "OAuth" }}
                      />
                    </>,
                  ]}
                /> */}
              </>,
            ]}
          />
          {event === "Create" && (
            <div>
              {!uploadedFile && (
                <div className="mt-1">
                  <span className="input-label">Upload Logo</span>
                  <div
                    className={`d-flex justify-content-center align-items-center radius-8px custom-bg-white-150 ${commoncss.dashedCard}`}
                    style={{ height: "70px" }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: "100px",
                            "flex-direction": "column",
                          }}
                        >
                          <div
                            className={bookclosurecss.addTBCardDescription}
                            style={{ color: "#B3C0BD" }}
                          >
                            Drag and drop your file here
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div
                className={`${commoncss.dFlex} mt-2`}
                style={{ gap: "10px" }}
              >
                {previewUrl && (
                  <div>
                    <img
                      src={previewUrl}
                      alt="Preview"
                      style={{
                        width: "100px",
                        height: "auto",
                      }}
                    />
                  </div>
                )}
                {uploadedFile && (
                  <button
                    className={wsCreationcss.perviewBtn}
                    type="button"
                    style={{ padding: "5px 7px" }}
                  >
                    <ImgIcon height={19} />
                    {uploadedFile.name}{" "}
                    <CloseIcon
                      height={15}
                      onClick={() => {
                        setUploadedFile(null);
                        setPreviewUrl(null);
                      }}
                    />
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default AddEditCompanyModal;
